import React from "react";
import PropTypes from "prop-types";
import { SecondaryButtonLink } from "../../../../components/Buttons";
import { PermissionResource, Resources } from "../../../Permissions";


function ReportTaskDashboard ({
  className,
  holderClassName,
}) {
  const renderItem = (label) => {
    return (
      <li className="no-pad-tb">
        <span>{label}</span>
      </li>
    );
  };

  let markup = (
    <SecondaryButtonLink
      id="userTasks"
      className={className}
      to="/aufgaben/reports"
      style={{ minHeight: "162px" }}
    >
      <h3 className="no-margin alg-center pad-big-top ">Reports</h3>
      <div
        className={`pad-top pad-big-btm w3-border-bottom margin-big-btm`}
        style={{marginLeft: "-14px", marginRight: "-14px"}}
      ></div>
      <ul className="w3-ul pad-big-btm">
        <PermissionResource
          resource={Resources.Tasks.Reports.MyTechie}
        >
          {renderItem("My Techie")}
        </PermissionResource>
        <PermissionResource
          resource={Resources.Tasks.Reports.LoginBehavior}
        >
          {renderItem("Loginverhalten")}
        </PermissionResource>
      </ul>
    </SecondaryButtonLink>
  );
  if (holderClassName) {
    markup = <div className={holderClassName}>{markup}</div>;
  }
  return markup;
}

ReportTaskDashboard.propTypes = {
  className: PropTypes.string,
  holderClassName: PropTypes.string,
};

ReportTaskDashboard.defaultProps = {
  className: "",
  holderClassName: null,
};

export default ReportTaskDashboard;
